<div class="container-fluid ddc-maintenance">
  <div>
    <img src="assets/img/ddc-logo-maintenance.svg" width="18%" />
  </div>
  <div class="ddc-mt-sm">
    <img src="assets/img/maintenance.png" width="30%" />
  </div>
  <div class="col-4 ddc-maintenance-message ddc-mt-sm">
    {{ maintenanceMessage }}
  </div>
  <div class="ddc-mt-sm">
    <input class="col-4 ddc-connection-button" type="submit" (click)="redirectToLogin()" value="Connexion"/>
  </div>
</div>
